<template>
  <div class="MaterialShed">
    <realData :isCameraFllow="isCF"></realData>
    <div class="item">
      <!-- <div @click="cameraMovetoEqu('0,1,VDM150,5')"></div>
      <div @click="cameraMovetoEqu('1,1,VDM150,5')"></div>
      <div @click="switchHL(0)"></div>
      <div @click="closeHL"></div> -->

      <!-- <div @click="getPos">记录当前位置</div> -->
      <!-- 
      <div @click="geEquipScreenPos">获取位置</div> -->
      <!-- <div @click="getPos">获取位置</div> -->
      <!-- <div @click="getPos">获取位置</div> -->
    </div>
    <alarmVue></alarmVue>
    <menuList></menuList>
    <menuBar ref="menuDom" :isCameraFllow="isCF"></menuBar>
    <menuControl></menuControl>
    <materialShedInfo v-if="showMaterialShedInfo"></materialShedInfo>
    <videoBox v-if="isRoad === 'shedScreen'" ref="videoBox" />
    <!-- <div @click="switchMaterialShedInfo">查看环保料场概况</div> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  switchOutside, //开关厂棚外侧
  switchLight, // 开关光照
  switchTarget, // 显隐光标
  switchPillar, // 显隐藏中立柱
  switchAllEqmHL, //开关设备高亮
  switchPartEqmHL, //开关部分设备高亮
  switchSingleHL, // 单个设备高亮
  ChangePileSizeFunc, //改变料堆大小
  switchAreaWarn, //开关告警区域
  switchAreaWarnClean, //开关已治理告警区域
  switchVDM3500, //开关vdm3500
  switchVDM150, //开关vdm150
  switchFogGun, // 开关雾炮
  switchMediaArea, //切换视频区域
  ChangeBarrelSizeFunc, //改变堆料大小
  switchBarrel, //开关料堆
  switchEqmWarn, //开关设备报警
  SelectEquipmentFunc, //选择设备
  switchMaterialCarSim, //开关布料小车仿真
  ContinueMaterialCarSimFunc, //继续仿真
  MaterialCarTurnToPileFunc, //小车皮带转向料堆
  MaterialCarTurnToBarrleFunc, //小车皮带转向料桶
  MaterialCarInitCameraPosFunc, //飞跃相机
  switchCarCamera, //启停相机动画
  switchSpray, //开启喷淋和落料动画
  switchCarBelt, // 开关小车皮带
  MaterialCarMoveFunc, // 小车移动
  switchStatusUI, // UI面板
  cameraMoveFun, //移动相机
  currentLocationFun, // 记录位置
  backToLocationFun, // 位置跳动
  ReturnEquipScreenPosFunc, // 返回设备2D坐标
  switchCameraControl, // 开关相机
  switchDetailStatusUI, //  面板2
  OpenDetectorUIFunc, // 含水率检测仪
  ReturnEquipPosFunc, // 返回设备3D坐标
  switchBottomCarBelt, // 下面皮带
  switchTopCarBelt, //上面皮带
  ChangeChainAngleFunc, // 挂料机角度
  CreateBrowserFunc,
  OpenBrowserFunc,
  CloseBrowserFunc,
  ScraperMoveFunc,
} from "@/assets/js/unity3D/shed.js";
import { defineComponent } from "vue";
import { ElNotification } from "element-plus";

import alarmVue from "@/modules/MaterialShedMod/alarmMod/alarm.vue";
import realData from "@/modules/MaterialShedMod/realDataMod/realData.vue";
import menuList from "@/modules/MaterialShedMod/menuListMod/menuList.vue";
import menuBar from "@/modules/MaterialShedMod/menuMod/menu.vue";
import menuControl from "@/modules/MaterialShedMod/menuControl/menuControl.vue";
import materialShedInfo from "@/modules/MaterialShedMod/materialShedInfoMod/materialShedInfo.vue";
import bottom_components_blueVue from "../../modules/bottomComponents/bottom_components_blue.vue";
import videoBox from "@/modules/videoComponents/videoBox.vue";
import { mapState } from "vuex";
import { computed } from "vue";

export default {
  components: {
    alarmVue,
    realData,
    menuBar,
    menuList,
    materialShedInfo,
    menuControl,
    videoBox,
  },
  // setup() {
  //   const openSuccess = (data) => {
  //     let word = (data[0] ? "西侧" : "东侧") + data[2] + "号区域";
  //     ElNotification({
  //       offset: 45,
  //       message: '<span style="color:green">治理成功:' + word + "</span>",
  //       dangerouslyUseHTMLString: true,
  //     });
  //   };

  //   const openWarn = (data) => {
  //     let word = (data[0] ? "西侧" : "东侧") + data[2] + "号区域";
  //     ElNotification({
  //       offset: 45,
  //       message: '<span style="color:red">告警区域:' + word + "</span>",
  //       dangerouslyUseHTMLString: true,
  //     });
  //   };

  //   const openInfo = (data) => {
  //     let word = (data[0] ? "西侧" : "东侧") + data[2] + "号雾炮";
  //     ElNotification({
  //       offset: 45,
  //       message: '<span style="color:black">设备已启动:' + word + "</span>",
  //       dangerouslyUseHTMLString: true,
  //     });
  //   };

  //   return {
  //     openSuccess,
  //     openWarn,
  //     openInfo,
  //   };
  // },
  data() {
    //这里存放数据
    return {
      VDM100: {},
      VDM150: {
        "0,1": { runStatus: true },
        "0,2": { runStatus: true },
        "1,1": { runStatus: true },
        "1,2": { runStatus: true },
      },
      VDM3500: {},
      FogGun: {},
      WaterRate: {},
      MaterialCar: {},
      Belt: {},
      Scraper: {},
      equipNoObj: {},
      equipStatusTimer: null,
      VDM100Status: {},
      VDM150Status: {},
      VDM3500Status: {},
      WaterRateStatus: {},
      FogGunStatus: {},
      BeltStatus: {},
      ScraperStatus: {},
      MaterialCarStatus: {},
      areaWarnList: {
        "0,1": { runStatus: true, FogGun: "0,1", rotate: 150 },
        "0,2": { runStatus: false, FogGun: "0,1", rotate: 120 },
        "0,3": { runStatus: false, FogGun: "0,1", rotate: 60 },
        "0,4": { runStatus: false, FogGun: "0,2", rotate: 135 },
        "0,5": { runStatus: false, FogGun: "0,2", rotate: 45 },
        "0,6": { runStatus: false, FogGun: "0,3", rotate: 120 },
        "0,7": { runStatus: false, FogGun: "0,3", rotate: 80 },
        "0,8": { runStatus: false, FogGun: "0,3", rotate: 40 },
        "1,1": { runStatus: false, FogGun: "1,1", rotate: 210 },
        "1,2": { runStatus: false, FogGun: "1,1", rotate: 240 },
        "1,3": { runStatus: false, FogGun: "1,1", rotate: 300 },
        "1,4": { runStatus: false, FogGun: "1,2", rotate: 225 },
        "1,5": { runStatus: false, FogGun: "1,2", rotate: 315 },
        "1,6": { runStatus: false, FogGun: "1,3", rotate: 240 },
        "1,7": { runStatus: false, FogGun: "1,3", rotate: 280 },
        "1,8": { runStatus: false, FogGun: "1,3", rotate: 320 },
      },
      timerObj: {},
      showMaterialShedInfo: false,
      materialCarInfo: {
        time: "10:30:45",
        alarmTime: "9:57:45",
        water: "129",
        unit: "m3/h",
        num: "100%",
        x: 1350,
        y: 220,
        isShow: false,
      },
      getRealData: false,
      isCF: false,
      boxInfo: "",
      nvrInfo: "",
      isRoad: bmeConfig.isRoad,
      VdmHisInfo: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({
      videoBox: "videoBoxSwitch",
    }),
  },
  provide: function () {
    return {
      //getImgUrl: computed(() => this.imgUrl),
      // startCameraMove: this.startPushShed1,

      //getMediaType: computed(() => this.mediaType),
      closeReal: this.closeReal,

      switchHL: this.switchHL,

      switchVideoArea: this.switchVideoArea,

      getEquipCurStatus: this.getEquipCurStatus,

      stopWarn: this.stopWarn,

      switchMaterialShedInfo: this.switchMaterialShedInfo,

      switchCF: this.switchCF,

      backPos: this.backPos,
      
      getBoxInfo: computed(() => this.boxInfo),

      getShedNvrInfo: computed(() => this.nvrInfo),

      updateNvrInfoBox: this.updateNvrInfoBox,
    };
  },
  //监控data中的数据变化
  watch: {
    "$store.state.videoBoxSwitch": {
      handler(val, oldVal) {
        let that = this;
        this.videoBoxSwitch = val;
        if (val === "open") {
          $(this.$refs.videoBox.$el).fadeIn(0, function () {
            $(that.$refs.videoBox.$el).css("display", "inital");
          });
        } else {
          this.$refs.videoBox.closeBtn()
          $(this.$refs.videoBox.$el).fadeOut(0);
        }
      },
      deep: true, //true 深度监听
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getRealData = bmeConfig.getRealData;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$getEquPos.cb = this.getEquPos;
    this.$cameraMove.cb = this.backPos;
    this.$getNowEquPos2D.cb = this.getNowEquPos2D;

    // this.$startPushShed2.cb = this.startPushShed2;
    // this.$startPushShed3.cb = this.startPushShed3;
    // this.$stratSpary.cb = this.stratSpary;
    // this.$camerawithSPS2.cb = this.camerawithSPS2;

    this.getEquipCurStatus();
    setTimeout(() => {
      //switchStatusUI("0,1,FogGun,雾炮,true", true);
      // for (let i in this.VDM150) {
      //   switchVDM150(i + ",1,0,0,0.5,0.15", true);
      // }
      // backToLocationFun("0,0,0");
      // OpenDetectorUIFunc(
      //   "0,1,Detector,矿类,6.07,1,1,1,1,移动布料小车，即将产生布料扬尘"
      // );
      // OpenDetectorUIFunc(
      //   "0,1,Detector,矿类,6.07,0,1,0,1,移动布料小车，即将产生布\n料扬尘"
      // );
      // switchDetailStatusUI("0,1,VDM150,VDM150,false,数据字段", true);
      //  CreateBrowserFunc(
      //     0,
      //     '0,1,VDM150',
      //     {
      //       runStatus: true,
      //       name: 'VDM150',
      //       deviceNos: '西区VDM150-001',
      //     },
      //     "baseInfo"
      //   );
      this.getNowEquPos2D();
    }, 500);
   
  },
  beforeUnmount() {},
  //方法集合
  methods: {
    updateNvrInfoBox(val, obj = 0) {
      this.nvrInfo = val;
      this.boxInfo = obj;
    },
    getPos() {
      currentLocationFun();
    },
    switchCF(value) {
      this.isCF = value;
    },
    closeReal() {
      switchMaterialCarSim("0,1,1", false);
      backToLocationFun("0,0,0");
    },
    // 获取实时设备二维位置
    getNowEquPos2D() {
      // console.log("获取实时设备二维位置");
      ReturnEquipScreenPosFunc();
    },
    getEquPos(pos) {
      backToLocationFun(this.moveEqu, pos);
    },
    // 镜头移动到设备方法 msg "0,1,VDM150" 或 "desiredDistance,xDeg,yDeg,x,y,z"
    backPos(msg) {
      // console.log(msg)
      if (msg.indexOf("Belt") != -1) return;
      if (!this.showMaterialShedInfo) {
        if (msg.indexOf(",baseInfo")) msg.replace(",baseInfo", "");
        if (msg.indexOf("MaterialCar") > -1 || msg.indexOf("Scraper") > -1) {
          this.moveEqu = msg;
          ReturnEquipPosFunc(msg);
        } else {
          backToLocationFun(msg);
        }
      }
    },
    // 查看环保料场概况
    switchMaterialShedInfo(arg) {
      if (arg) {
        this.showMaterialShedInfo = true;
      } else {
        this.showMaterialShedInfo = false;
      }
    },
    // 根据设备类型 高亮
    //@type 0 生产设备 1 治理设备 2 监测设备
    switchHL(type) {
      // 没用到的 "StockPile，MatBarrel，"; ,
      let list = [
        ["MaterialCar", "Belt", "Scraper"],
        ["FogGun"],
        ["VDM100", "VDM150", "VDM3500", "Detector"],
      ];
      switchAllEqmHL(false);
      switchPartEqmHL("MaterialCar", false);
      list[type].forEach((i) => {
        switchPartEqmHL(i, true);
      });
    },
    closeHL() {
      switchAllEqmHL(false);
    },
    // 视频区域打开
    switchVideoArea(isOpen) {
      let videoAreaList = [
        "0,1",
        "0,2",
        "0,3",
        "0,4",
        "0,5",
        "0,6",
        "0,7",
        "0,8",
        "1,1",
        "1,2",
        "1,3",
        "1,4",
        "1,5",
        "1,6",
        "1,7",
        "1,8",
      ];
      videoAreaList.forEach((i) => {
        switchMediaArea(i + ",AreaWarn", isOpen);
      });
    },
    // 开启模拟治理
    getEquipCurStatus() {
      if (this.getRealData) {
        return;
      }
      setTimeout(() => {
        let keyList = Object.keys(this.areaWarnList);
        let n = Math.floor(keyList.length * Math.random());
        let selectedKey = keyList[n];
        for (let i in this.areaWarnList) {
          let warnObj = this.areaWarnList[i];
          let warnName = i;
          this.renderWarnRegion(warnObj, warnName, selectedKey);
        }
        //this.getWarnRunStatus();
      }, 2000);

      if (this.areaWarnTimer) {
        clearInterval(this.areaWarnTimer);
      }
      this.areaWarnTimer = setInterval(() => {
        //let warnNum = Math.round(Math.random())+1;
        let keyList = Object.keys(this.areaWarnList);
        let n = Math.floor(keyList.length * Math.random());
        let selectedKey = keyList[n];
        for (let i in this.areaWarnList) {
          let warnObj = this.areaWarnList[i];
          let warnName = i;
          this.getWarnRegion(warnObj, warnName, selectedKey);
        }
        //this.getWarnRunStatus();
      }, 30000);
    },
    getWarnRegion(warnObj, warnName, selectedKey) {
      if (this.timerObj[warnName]) {
        clearTimeout(this.timerObj[warnName]);
      }
      this.timerObj[warnName] = setTimeout(() => {
        this.renderWarnRegion(warnObj, warnName, selectedKey);
      }, Math.random() * 30 * 1000);
    },
    // 判断是否渲染
    renderWarnRegion(warnObj, warnName, selectedKey) {
      if (!warnObj.runStatus) {
        warnObj.runStatus = selectedKey == warnName ? true : false; //Math.random() > 0.8;
        if (warnObj.runStatus) {
          setTimeout(() => {
            if (warnName) {
              this.openWarn(warnName);
            }
          }, 500);

          this.timerObj[warnName + "1"] = setTimeout(() => {
            this.getWarnRunSingleStatus(warnName, function () {
              warnObj.runStatus = false;
            });
          }, 500);
        }
      }
    },
    // 单个告警
    getWarnRunSingleStatus(i, cb) {
      switchAreaWarn(i + ",AreaWarn", this.areaWarnList[i].runStatus);
      let fg = this.areaWarnList[i].FogGun;
      let ro = this.areaWarnList[i].rotate;
      if (this.areaWarnList[i].runStatus) {
        let tmpTime = Math.random() * 10 + 5;
        this.timerObj[i + "1"] = setTimeout(() => {
          this.openInfo(fg);
          switchFogGun(fg + "," + ro, true);
          // switchStatusUI(fg + ",FogGun,雾炮,true", true);
          // switchStatusUI("0,1,FogGun,雾炮,true", true);
        }, tmpTime * 1000);
        this.timerObj[i + "2"] = setTimeout(() => {
          this.openSuccess(i);
          switchAreaWarn(i + ",AreaWarn", false);
          switchFogGun(fg, false);
          // switchStatusUI(fg + ",FogGun", false);
          switchAreaWarnClean(i + ",ResolvedArea", true);
        }, (tmpTime + 8) * 1000);
        this.timerObj[i + "3"] = setTimeout(() => {
          switchAreaWarnClean(i + ",ResolvedArea", false);
          if (cb) {
            cb();
          }
        }, (tmpTime + 13) * 1000);
      }
    },
    // 关闭模拟治理
    stopWarn() {
      if (this.areaWarnTimer) {
        clearInterval(this.areaWarnTimer);
      }
      if (this.timerObj) {
        for (let i in this.timerObj) {
          clearTimeout(this.timerObj[i]);
        }
      }
      for (let i in this.areaWarnList) {
        switchFogGun(this.areaWarnList[i].FogGun, false);
        switchAreaWarnClean(i + ",ResolvedArea", false);
        switchAreaWarn(i + ",AreaWarn", false);
        // switchStatusUI(this.areaWarnList[i].FogGun + ",FogGun", false);
      }
    },
    geEquipScreenPos() {
      ReturnEquipScreenPosFunc();
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss'>
.MaterialShed {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  pointer-events: auto;
  .item {
    margin-top: 280px;
    > div {
      width: 200px;
      height: 50px;
      background: black;
      margin-top: 20px;
    }
  }
}
.shedNote {
  width: 280px;
  background-color: rgba(2, 21, 44, 0.7) !important;
  border: none !important;
  .el-icon-success {
    --el-notification-icon-color: var(--el-color-success);
  }
  .el-icon-info {
    --el-notification-icon-color: var(--el-color-success);
  }
  .el-icon-warning {
    --el-notification-icon-color: var(--el-color-error);
  }
}
</style>